/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { RestoreUsernamesErrorResponse, RestoreUsernamesRequest } from './api.schemas';

import { api } from '../util/http';

export const restoreUsernames = (
  restoreUsernamesRequest: RestoreUsernamesRequest,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/api/auth/restore-usernames`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: restoreUsernamesRequest,
    signal,
  });
};

export const getRestoreUsernamesMutationOptions = <
  TError = RestoreUsernamesErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreUsernames>>,
    TError,
    { data: RestoreUsernamesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreUsernames>>,
  TError,
  { data: RestoreUsernamesRequest },
  TContext
> => {
  const mutationKey = ['restoreUsernames'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreUsernames>>,
    { data: RestoreUsernamesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return restoreUsernames(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreUsernamesMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreUsernames>>
>;
export type RestoreUsernamesMutationBody = RestoreUsernamesRequest;
export type RestoreUsernamesMutationError = RestoreUsernamesErrorResponse;

export const useRestoreUsernames = <TError = RestoreUsernamesErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreUsernames>>,
      TError,
      { data: RestoreUsernamesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof restoreUsernames>>,
  TError,
  { data: RestoreUsernamesRequest },
  TContext
> => {
  const mutationOptions = getRestoreUsernamesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
